import { localsList } from '@/utils/locals'

export default function getLangFromLocale(locale = 'us') {
    let obj = {};

    for(let key in localsList) {
        const list = localsList[key] || [];
        for(let i = 0; i < list.length; i++) {
            const item2 = list[i] || {};

            if(item2.local === locale) {
                obj = item2;
            }
        }
    }
    
    return obj;
};